import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 20px;
`;

const PageHeader = styled.div`
  margin-bottom: 32px;
  
  h1 {
    font-size: 28px;
    margin-bottom: 8px;
  }
  
  p {
    color: ${props => props.theme.colors.textLight};
  }
`;

const ComingSoon = styled.div`
  background: ${props => props.theme.colors.surface};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 12px;
  padding: 48px;
  text-align: center;
  
  .icon {
    font-size: 64px;
    margin-bottom: 24px;
  }
  
  h2 {
    margin-bottom: 16px;
  }
  
  p {
    color: ${props => props.theme.colors.textLight};
    max-width: 400px;
    margin: 0 auto;
  }
`;

const NutritionLog = () => {
  return (
    <Container>
      <PageHeader>
        <h1>Nutrition Log</h1>
        <p>Track your meals and monitor your nutritional intake</p>
      </PageHeader>
      
      <ComingSoon>
        <div className="icon">🍽️</div>
        <h2>Coming Soon</h2>
        <p>
          The nutrition logging interface is being built. For now, use the chat 
          interface to log your meals by describing what you ate.
        </p>
      </ComingSoon>
    </Container>
  );
};

export default NutritionLog;